import { useEffect, useRef } from 'react';
import H from '@here/maps-api-for-javascript';
import { createAnimationPool, updateAnimationPool, SEGMENTS_AMOUNT } from './utils/animationUtils';

const ANIMATION_INTERVAL = 555;

const NewMapAnimatedTour = ({ map, tour, display }) => {
  const groupRef = useRef(null);
  const poolRef = useRef([]);
  const stepRef = useRef(0);
  const displayRef = useRef(display);

  useEffect(() => {
    displayRef.current = display;
  });

  useEffect(() => {
    if (!map || !tour) return undefined;

    groupRef.current = new H.map.Group();
    map.addObject(groupRef.current);

    const pool = createAnimationPool(tour, displayRef.current);
    poolRef.current = pool;
    pool.forEach((p) => groupRef.current.addObject(p));

    const tick = () => {
      stepRef.current = stepRef.current >= SEGMENTS_AMOUNT ? 0 : stepRef.current + 1;
      updateAnimationPool(poolRef.current, tour, displayRef.current, stepRef.current);
    };

    const intervalId = setInterval(tick, ANIMATION_INTERVAL);

    return () => {
      clearInterval(intervalId);
      if (groupRef.current) {
        groupRef.current.removeAll();
        map.removeObject(groupRef.current);
        groupRef.current = null;
      }
      poolRef.current = [];
    };
  }, [map, tour]);

  return null;
};

export default NewMapAnimatedTour;
